import { PriceListRow } from "../types/PriceListRow";

export type PriceListSortKey = keyof PriceListRow;

export interface PriceListSortState {
  key: PriceListSortKey;
  desc: boolean;
}

const isNumeric = (value: string) =>
  value.trim() !== "" && Number.isFinite(Number(value));

const comparePresentValues = (
  a: string | number,
  b: string | number
): number => {
  if (typeof a === "number" && typeof b === "number") {
    return a - b;
  }
  const left = String(a);
  const right = String(b);
  if (isNumeric(left) && isNumeric(right)) {
    return Number(left) - Number(right);
  }
  return left.localeCompare(right);
};

export type PriceListSortValue = string | number | null | undefined;

export type PriceListSortValueResolver = (
  row: PriceListRow,
  key: PriceListSortKey
) => PriceListSortValue;

const rawFieldValue: PriceListSortValueResolver = (row, key) =>
  row[key] as PriceListSortValue;

const compareValues = (
  a: PriceListSortValue,
  b: PriceListSortValue,
  desc: boolean
): number => {
  if (a == null || b == null) {
    return a == null && b == null ? 0 : a == null ? 1 : -1;
  }
  const order = comparePresentValues(a, b);
  return desc ? -order : order;
};

export const sortPriceListRows = (
  rows: PriceListRow[],
  { key, desc }: PriceListSortState,
  sortValue: PriceListSortValueResolver = rawFieldValue
): PriceListRow[] =>
  [...rows].sort((a, b) =>
    compareValues(sortValue(a, key), sortValue(b, key), desc)
  );
